<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="tableData"
      :item-key="uniqueIdentifier"
      class="elevation-1"
    >
      <template v-slot:item.index="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon 
          v-if="endpoint === 'person'"
          color="primary" 
          small 
          @click="openEditDialog(item)"
          style="margin-right: 8px;"
        >
          mdi-pencil
        </v-icon>
        <v-icon color="red" small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="updatingLoading">
      {{ loadingText }}
    </v-snackbar>

    <!-- Edit Person Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>Edit Contact</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editingPerson.name"
                  label="Name"
                  outlined
                  dense
                  :disabled="updatingLoading"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editingPerson.email"
                  label="Email"
                  outlined
                  dense
                  :disabled="updatingLoading"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editingPerson.type"
                  :items="contactTypes"
                  label="Contact Type"
                  outlined
                  dense
                  :disabled="updatingLoading"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeEditDialog()">Cancel</v-btn>
          <v-btn 
            color="primary" 
            text 
            @click="saveEditedPerson()"
            :disabled="updatingLoading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import msalAuthHandler from "vue-msal-wrapper";
export default {
  props: [
    "headers",
    "tableData",
    "storeKey",
    "uniqueIdentifier",
    "disabled",
    "endpoint",
  ],
  data() {
    return {
      updatingLoading: false,
      loadingText: `Removing ${this.endpoint}...`,
      editDialog: false,
      editingPerson: {
        id: null,
        name: "",
        email: "",
        type: "",
      },
      contactTypes: [],
    };
  },
  methods: {
    openEditDialog(item) {
      if (this.disabledComputed) {
        return;
      }
      // Load contact types if not already loaded
      if (this.contactTypes.length === 0) {
        msalAuthHandler
          .authenticatedApi(this.$store.state.apiUrl, "backend")
          .get(`personTypes`, {})
          .then((response) => {
            this.contactTypes = response.data.data;
          });
      }
      // Create a copy of the item to edit
      this.editingPerson = { ...item };
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editingPerson = {
        id: null,
        name: "",
        email: "",
        type: "",
      };
    },
    saveEditedPerson() {
      // Validate fields
      const isEmailRequired = this.editingPerson.type !== "USER";
      if (
        !this.editingPerson.name ||
        !this.editingPerson.type ||
        (isEmailRequired && !this.editingPerson.email)
      ) {
        return;
      }

      this.updatingLoading = true;
      this.loadingText = "Updating contact...";

      msalAuthHandler
        .authenticatedApi(this.$store.state.apiUrl, "backend")
        .patch(
          `person/${this.editingPerson.id}`,
          JSON.stringify({
            name: this.editingPerson.name,
            email: this.editingPerson.email?.trim() || null,
            type: this.editingPerson.type,
          })
        )
        .then((response) => {
          // Find and update the person in the store - create new array to trigger reactivity
          const personIndex = this.$store.state.activeClient[this.storeKey].findIndex(
            (p) => p.id === this.editingPerson.id
          );
          if (personIndex >= 0) {
            // Create a new array with the updated person to ensure Vue detects the change
            const updatedArray = [...this.$store.state.activeClient[this.storeKey]];
            updatedArray[personIndex] = {
              ...updatedArray[personIndex],
              name: this.editingPerson.name,
              email: this.editingPerson.email,
              type: this.editingPerson.type,
            };
            // Reassign the entire array to force Vue's reactivity
            this.$store.state.activeClient[this.storeKey] = updatedArray;
          }
          this.updatingLoading = false;
          this.loadingText = `Removing ${this.endpoint}...`;
          this.closeEditDialog();
        })
        .catch((error) => {
          console.error("Error updating person:", error);
          this.updatingLoading = false;
          this.loadingText = `Removing ${this.endpoint}...`;
        });
    },
    deleteItem(item) {
      if (this.disabledComputed) {
        return;
      }
      this.updatingLoading = true;

      msalAuthHandler
        .authenticatedApi(this.$store.state.apiUrl, "backend")
        .delete(`${this.endpoint}/${item.id}`, {})
        .then((response) => {
          this.$store.state.activeClient[this.storeKey] =
            this.$store.state.activeClient[this.storeKey].filter(
              (i) => i.id !== item.id
            );
          this.updatingLoading = false;
        });
    },
  },
  computed: {
    disabledComputed() {
      return this.disabled;
    },
  },
};
</script>
